import { Markdown } from '@cadstrom/sigma-engine-shared';

import { severityGlyph } from '#src/routes/results/analysis-results-page/requirements-v2-tab/shared/severity-glyph.js';

export interface SeverityMarkdownItemProps {
	severity?: string;
}

/**
 * Renders a markdown severity reference (`:severity[pass]`) as the same glyph the
 * assertion result cards use for that severity. An unrecognised value falls back
 * to its text so the reader still sees something.
 */
export function SeverityMarkdownItem(props: SeverityMarkdownItemProps) {
	if (props.severity === undefined) {
		return null;
	}
	const severity = Markdown.parseSeverityDirectiveValue(props.severity);
	if (severity === undefined) {
		return <span>{props.severity}</span>;
	}
	const { Icon, colorClass, label } = severityGlyph[severity];
	return (
		<span className={`mx-0.5 inline-flex items-center align-middle ${colorClass}`} title={label}>
			<Icon fontSize='inherit' aria-label={label} />
		</span>
	);
}
